let REQUEST_ACCEPTED = '受付しました。';
let REQUEST_ACCEPTED_OK_BUTTON = 'OK';

export default { REQUEST_ACCEPTED, REQUEST_ACCEPTED_OK_BUTTON };
